import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { GRID } from '../../constants';
var generalStyles = facepaintMediaQueries({
  display: ['block', 'grid'],
  gridGap: [GRID.xsmall, GRID.xsmall, GRID.small],
  gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr 1fr'],
  marginTop: [GRID.small, GRID.small, GRID.large],
  marginBottom: GRID.xsmall,
  boxSizing: 'border-box',
  '> *': {
    marginBottom: [GRID.xsmall, GRID.xsmall, 0]
  }
});
var internetExplorer11Styles = facepaintMediaQueries({
  display: ['block', '-ms-grid'],
  msGridColumns: ['1fr', "1fr " + GRID.xsmall + " 1fr", "(1fr " + GRID.small + ")[3] 1fr"],
  '& > :nth-child(1)': {
    msGridColumn: 1
  },
  '& > :nth-child(2)': {
    msGridColumn: 3
  },
  '& > :nth-child(3)': {
    msGridRow: [2, 2, 1],
    msGridColumn: [1, 1, 5]
  },
  '& > :nth-child(4)': {
    msGridColumn: [3, 3, 7],
    msGridRow: [2, 2, 1]
  }
});
export var FourColumns = function FourColumns(_a) {
  var children = _a.children;
  return jsx("div", {
    css: [internetExplorer11Styles, generalStyles]
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Grid/FourColumns.js
// module id = 827
// module chunks = 0